import {FC} from "react";
import styled from "styled-components";
import {useTranslation} from "react-i18next";
import {getLogo} from "modules/utils";
import {PlayerStats, ProfileWithBadges} from "components";
import bg from "assets/images/gamebar-bg.png";

const Wrapper = styled.div`
	width: 100%;
	font-family: "Khand", sans-serif;
	color: ${({theme}) => theme.color.tertiary};
	text-align: left;
	padding: 20px 33px;
	background: url(${bg}) no-repeat left;
	background-size: cover;

	@media (min-width: 769px) {
		background-position: center;
		padding: 40px 60px;
	}
`;

const Container = styled.div`
	width: 100%;
	max-width: 1230px;
	margin: 0 auto;
	display: flex;
	justify-content: space-between;
	flex-direction: column;
	align-items: flex-start;

	@media (min-width: 769px) {
		flex-direction: row;
	}
`;

const Info = styled.div`
	display: flex;
	flex-direction: column;
	margin-top: 20px;
	width: 100%;
	align-items: center;

	@media (min-width: 769px) {
		align-items: flex-end;
		margin-top: 0;
		width: auto;
	}
`;

const Img = styled.img`
	height: 54px;
	margin-bottom: 10px;
	display: none;

	@media (min-width: 769px) {
		display: block;
	}
`;

export const BadgesGameBar: FC = () => {
	const {i18n} = useTranslation();
	const logo = getLogo(i18n.language);

	return (
		<Wrapper>
			<Container>
				<ProfileWithBadges />

				<Info>
					<Img src={logo} alt="Game Zone" />

					<div>
						<PlayerStats />
					</div>
				</Info>
			</Container>
		</Wrapper>
	);
};
